<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
             <b-card-code >
                <validation-observer ref="simpleRules">
                    <form @submit.prevent="submitForm">
                      <b-row>
                        <b-col md="4">
                          <b-form-group>
                            <label>Country</label>
                            <v-select v-model="state" placeholder="None" :options="stateOptions" label="State" @input="handleCity()" />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>State</label>
                            <v-select v-model="state" placeholder="None" :options="stateOptions" label="State" @input="handleCity()" />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <label>City</label>
                            <v-select v-model="city" :options="cityOption" @input="clickArea($event)" label="City" placeholder="None" />
                          </b-form-group>
                        </b-col>
                        <!-- <b-col md="6">
                          <b-form-group>
                            <label>Select Date</label>
                            <flat-pickr class="form-control"
                              value=""
                              :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range'}"
                              placeholder="Select Date"
                              style="background-color: transparent"
                              @input="getdata($event)"/>
                          </b-form-group>
                        </b-col> -->
                        <!-- <b-col md="6">
                          <b-form-group>
                            <label>Branch</label>
                            <v-select v-model="branch" label="name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None" :options="['Channel Partner','Franchise','Admin']" @input="getEmployee()"
                            />
                          </b-form-group>
                        </b-col> -->
                        <!-- <b-col md="6" v-if="branch == 'Channel Partner' || branch=='Franchise'">
                          <b-form-group>
                            <label>Select {{ branch }}</label>
                            <v-select v-model="employee" label="name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None" :options="employeeoption" @input="getUsers()"
                            />
                          </b-form-group>
                        </b-col> -->
                        <!-- <b-col md="6">
                          <b-form-group>
                            <label>Select Sub Employee</label>
                            <v-select v-model="subemployee" label="name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None" :options="subemployeeoption"
                            />
                          </b-form-group>
                        </b-col> -->
                      </b-row>
                      <div class="d-flex justify-content-end">
                        <b-button  variant="primary" class="ml-2" @click="searchData">
                          <feather-icon icon="SearchIcon" class="mr-50" />
                          <span class="align-middle">Search</span>
                        </b-button>
                      </div>
                    </form>
                </validation-observer>
            </b-card-code>
              <report-table
                :data="data"
                :columns="fields"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportTable from '../../../components/ReportTable.vue'
import axios from '@/components/axios'
import BCardCode from '@core/components/b-card-code'
import flatPickr from 'vue-flatpickr-component'
import GoodTableColumnSearch from '../../../components/GoodTableColumnSearch.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Form from '@/components/form/Form.vue'
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton
} from 'bootstrap-vue'
const baseApi = process.env.VUE_APP_APIENDPOINT
import vSelect from 'vue-select'
export default {
  components: {
    ReportTable,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    Form,
    GoodTableColumnSearch
  },
  data () {
    return {
      country:'',
      countryOption:[],
      state:'',
      stateOptions:[],
      city:'',
      cityOption:[],
      branch: '',
      startdate: '',
      enddate: '',
      employee: '',
      employeeoption: [],
      subemployee: '',
      subemployeeoption: [],
      data: '',
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken:localStorage.getItem('accessToken'),
      fields: [
        { field: 'id', label: 'S.R. No',  },
        { field: 'branch', label: 'Branch',  },
        { field: 'location', label: 'Location',  },
        { field: 'landdetails', label: 'Land Details',  },
        { field: 'name', label: 'Name',  },
        { field: 'at', label: 'At',  },
        { field: 'taluka', label: 'Taluka',  },
        { field: 'district', label: 'District',  },
        { field: 'mobile', label: 'Mobile No', },
        { field: 'group', label: 'Group',  },
        { field: 'year', label: 'Year',  },
        { field: 'cast', label: 'Cast',  },
        { field: 'investamount', label: 'Invest Amount',  },
        { field: 'cpempfran', label: 'CP/EMP/FRAN',  },
      ]
    }
  },
  mounted(){
    this.getState()
  },
  methods: {
    async getState() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getState`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.stateOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async handleCity() {
      this.areaOption = [];
      this.cityOption = [];
      this.fromState = true;
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getCityByState`,
        data: {
          State: this.state,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.cityOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    clickArea(e) {
      if (this.fromState == true) {
        this.handleArea();
      }
      // console.log("first")
      //   this.areaOption = []
      // this.StateData.map((item) => {
      //   if (item.City == e) {
      //     this.areaOption.push(item.PostOfficeName)
      //   }
      // })
    },
    getdata (selectedDates) {
      this.result = selectedDates.split(' to ')
      this.startdate = this.result[0]
      this.enddate = this.result[1]
    },
    async searchData () {
      const data = {
        employee_id:this.subemployee.id,
        startdate:this.startdate,
        enddate:this.enddate
      }
      await axios({
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Authorization': `Bearer ${this.accessToken}`
        },
        data:JSON.stringify(data),
        url:`${this.baseApi}/customerdatabank`
      })
        .then((response) => {
          this.data = response.data.data
        })
    },
    async getEmployee () {
      this.employee = ''
      this.subemployee = ''
      this.employeeoption = []
      this.subemployeeoption = []

      if (this.branch == 'Channel Partner') {

        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getChannelpartner`
        }
        await axios(requestOptions)
          .then((response) => {
            this.employeeoption = response.data.data
          })
          .catch((error) => console.log(error, 'error'))
      } else if (this.branch == 'Franchise') {
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/getFranchise`
        }
        await axios(requestOptions)
          .then((response) => {
            this.employeeoption = response.data.data
          })
          .catch((error) => console.log(error, 'error'))
      } else if (this.branch == 'Admin') {

        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.accessToken}`
          },
          url: `${this.baseApi}/team`
        }
        await axios(requestOptions)
          .then((response) => {
            this.subemployeeoption = response.data.data.data
          })
          .catch((error) => console.log(error, 'error'))
      }
    },
    async getUsers () {
      this.subemployee = ''
      this.subemployeeoption = []
      const id = this.employee.id
      this.employeeoption.map((item) => {
        if (id == item.parent) {
          this.subemployeeoption.push(item)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
